import React from 'react'

import IconCabel from 'assets/icons/Cabel.png'
import IconIPTV from 'assets/icons/IPTV.png'
import IconTV from 'assets/icons/Kion.png'
import IconSputnik from 'assets/icons/Sputnik.png'

import classes from './MainWorkAreas.module.scss'

export const MainWorkAreasId = 'main-work-areas-block'

export const MainWorkAreas = (): JSX.Element => {
  const items = [
    {
      icon: IconTV,
      title: 'KION',
      descr: 'Онлайн-кинотеатр с оригинальным контентом',
    },
    {
      icon: IconSputnik,
      title: 'Спутниковое ТВ',
      descr:
        'Более 200 телеканалов в высоком качестве 4K и HD, доступные даже там, где нет интернета',
    },
    {
      icon: IconCabel,
      title: 'Кабельное ТВ',
      descr:
        'Любимые сериалы, фильмы и премиальные телеканалы по доступным тарифам у вас дома',
    },

    {
      icon: IconIPTV,
      title: 'IPTV',
      descr:
        'Телевидение с интерактивными функциями: пауза, перемотка, запись и доступ к архиву',
    },
  ]

  return (
    <div id={MainWorkAreasId} className={classes.wrap}>
      <div className="container">
        <h2
          className="reveal-from-bottom-large second-title"
          data-reveal-delay={30}
        >
          Основные направления <br /> деятельности
        </h2>
        <div className={`${classes.items} row`}>
          {items.map((item, itemIndex) => {
            return (
              <div
                key={itemIndex}
                className={`${classes.items__item} col-xs-12 col-sm-6 col-lg-3 reveal-from-bottom-medium`}
                data-reveal-delay={(itemIndex + 1) * 100}
              >
                <img src={item.icon} alt="icon"></img>
                <div className={classes.title}>{item.title}</div>
                <div className={classes.descr}>{item.descr}</div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
